module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/marquee_desktop2-aee32d97d6a2fb5d3fa732febff5f720.jpg";